/** 
 * 操作聚合应用的方法类
 */
import ArrayUtil from "Pub/js/arrayUtil";

export default class AppGroupAction {
    constructor(props) {
        const { appGroupMap, id, updateAppGroup } = props;
        this.key = id;
        this.appGroups = new ArrayUtil(appGroupMap[id]);
        this.updateAppGroup = updateAppGroup;
    }

    /**
     * 在指定位置添加Item
     *
     * @param {*} newItems 添加Item信息
     * @param {*} position 添加Item的位置index
     */
    add(newItems, position, upSide = false) {
        let newAppGroups = this.appGroups.add(newItems);
        if (position !== undefined) {
            newAppGroups = this.appGroups.insert(position, newItems);
        }
        this.updateCurrentAppGroup(newAppGroups, upSide);
    }

    /**
     * 根据index删除指定Item
     *
     * @param {*} index 删除Item的index
     */
    remove(index, upSide = false) {
        const appGroups = this.appGroups.remove(index);
        this.updateCurrentAppGroup(appGroups, upSide);
    }

    /**
     * 根据指定key删除Item
     *
     * @param {*} key 删除Item依赖的字段
     * @param {*} value 删除Item依赖的字段值
     */
    removeByKey(key, value) {
        let appGroups = this.appGroups.getArray();
        appGroups = appGroups.filter(item => item[key] !== value);
        this.updateCurrentAppGroup(JSON.parse(JSON.stringify(appGroups)));
    }
    /**
     * 移动Item位置
     *
     * @param {*} dragIndex 移动Item的index
     * @param {*} targetIndex 目标Item的index
     */
    move(dragIndex, targetIndex) {
        const newAppGroups = this.appGroups.move(dragIndex, targetIndex);
        this.updateCurrentAppGroup(newAppGroups);
    }
    /**
     * 勾选Item
     *
     * @param {*} index 勾选的index
     * @param {*} checked 选中状态
     */
    check(index, checked) {
        let appGroups = this.appGroups.getArray();
        if (appGroups[index]) {
            appGroups[index].isChecked = checked;
        }
        this.updateCurrentAppGroup(appGroups);
    }
    //更新store
    updateCurrentAppGroup(data, upSide = true) {
        this.appGroups.update(data);
        this.updateAppGroup(this.key, data, upSide);
    }
    /**
     * 根据id获取修改Item信息
     *
     * @param {*} id Item的id
     * @param {*} properties 修改Item的字段
     */
    updateAppProperties(id, properties) {
        let appGroups = this.appGroups.getArray();
        const targetIndex = appGroups.findIndex(item => item.cardid === id);
        if (targetIndex !== -1) {
            appGroups[targetIndex] = { ...appGroups[targetIndex], ...properties };
        }
        this.updateCurrentAppGroup(appGroups, true); // 这里目前只有常用链接在用，需要更新侧拉，不然聚合应用内改完名字，侧拉不会变
    }

    getData() {
        return this.appGroups.getArray();
    }
}
